import classNames from "classnames";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { ImageFlux } from "@components/ImageFlux";
import type { ReservationMatchOptionItem_ReservationMatchOptionFragment } from "@components/ReservationMatchOptionItem/__generated__/fragments";
import { TeamsByTournamentState } from "@hooks/useTeamsByTournament";
import { toJpTime } from "@libs/utils/date";
import { notSelectedValue } from "../../pages/shops/[uuid]/request_reservation";
import styles from "./index.module.css";

type Props = {
  matchOption: ReservationMatchOptionItem_ReservationMatchOptionFragment;
};

const ReservationMatchOptionItem: React.FC<Props> = ({ matchOption }) => {
  const { register } = useFormContext();
  const { allTeams } = TeamsByTournamentState.useContainer();

  const match = matchOption.match;
  const newsArticles = matchOption.newsArticles;
  return (
    <div className={styles.radio}>
      <label>
        <input
          {...register("matchId")}
          type="radio"
          value={match ? match.id.toString() : notSelectedValue}
        />
        <div className={classNames(styles.label, styles.matchCard)}>
          {match ? (
            <>
              <div className={styles.leagueName}>
                {match.masterTournament?.displayName}
              </div>
              <div className={styles.match}>
                {match.homeTeamDisplayShortName} vs{" "}
                {match.awayTeamDisplayShortName} [
                {match.startsAt && toJpTime(match.startsAt)} 試合開始]
              </div>
            </>
          ) : (
            "試合観戦なし・その他"
          )}
          {newsArticles.length > 0 && (
            <div className={styles.matchEvent}>
              {newsArticles.map((newsArticle) => {
                const team = allTeams.find(
                  (t) => t.id === newsArticle.masterTeam?.id
                );
                return (
                  <div className={styles.matchEventItems} key={newsArticle.id}>
                    <div className={styles.eventThumbnail}>
                      <ImageFlux
                        imageType="thumbnail"
                        url={newsArticle.imageUrl}
                        alt={newsArticle.imageAlt}
                      />
                    </div>
                    <div className={styles.eventInfo}>
                      <div className={styles.eventName}>
                        {newsArticle.title}
                      </div>
                      {team && (
                        <div className={styles.teamLabel}>
                          <div className={styles.teamLogo}>
                            <img src={team.iconPath ?? ""} alt={team.name} />
                          </div>
                          <span>{team.shortName}</span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </label>
    </div>
  );
};

export default ReservationMatchOptionItem;
